import * as React from 'react';
import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

const CircularProgressWithLabel = (props) => {
    return (
        <Box sx={{ position: 'relative', display: 'flex', flexDirection: "row-reverse" }}>
            <CircularProgress variant="determinate" thickness={10} size="5rem" {...props} />
            <Box
                sx={{
                    top: 0,
                    left: 0,
                    bottom: 0,
                    right: 0,
                    position: 'absolute',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                <Typography variant="caption" component="div" color="text.secondary" sx={{ position: "absolute", top: "39%", right: "13%", fontWeight: "bold", opacity: "1" }}>
                    {`${Math.round(props.value)}%`}
                </Typography>
            </Box>
        </Box>
    );
}

CircularProgressWithLabel.propTypes = {
    /**
     * The value of the progress indicator for the determinate variant.
     * Value between 0 and 100.
     * @default 0
     */
    value: PropTypes.number.isRequired,
};

export default function ProgressDonut({ progressVal }) {
    const [progress, setProgress] = React.useState(0);

    useEffect(() => {
        setProgress(progressVal);
    }, []);

    return <CircularProgressWithLabel value={progress} />;
}